import React from "react";
import { Row, Typography, Select, Form, Divider, Col, Button } from "antd";
import { RightOutlined, DownOutlined } from "@ant-design/icons";
import ConfigureFundSource from "./ConfigureFundSource";
import MapFees from "./MapFees";
import { BOM } from "../../../../../../services/definedMethod";
import { labelConfig } from "../../../../product.config";
const { Title } = Typography;

const AccountingForm = (props) => {
  const {
    onFinish,
    form,
    formData,
    showAdvancedAccounting,
    setShowAdvancedAccounting,
    assetAccountOptions,
    equityAccountOptions,
    expenseAccountOptions,
    incomeAccountOptions,
    liabilityAccountOptions,
    charges,
    penaltyOptions,
    paymentTypeOptions,
    userData,
    isLoading,
    setIsLoading,
    configureFundTableSource,
    setConfigureFundTableSource,
    fundCount,
    setFundCount,
    feeCount,
    setFeeCount,
    penaltyCount,
    setPenaltyCount,
    mapFeeTableSource,
    setMapFeeTableSource,
    mapPenaltyTableSource,
    setMapPenaltyTableSource,
    isDormancyTrackingActive,
  } = props;

  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      form={form}
      initialValues={formData}
    >
      <div>
        <div>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {labelConfig.assets}
            </Title>
          </Divider>
          <Row>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.savingReference}
                name="savingsReferenceAccountId"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.savingReference),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  options={assetAccountOptions}
                  placeholder={"Select an Option"}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>

            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="overdraftPortfolioControlId"
                label={labelConfig.overdraftPortfolio}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Overdraft Portfolio"),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  options={assetAccountOptions}
                  placeholder={"Select an Option"}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {labelConfig.liabilities}
            </Title>
          </Divider>
          <Row>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="savingsControlAccountId"
                label={labelConfig.savingControl}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Savings Control"),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  options={liabilityAccountOptions}
                  placeholder={"Select an Option"}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="transfersInSuspenseAccountId"
                label={labelConfig.savingsTransfersInSuspense}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(
                      labelConfig.savingsTransfersInSuspense
                    ),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  options={liabilityAccountOptions}
                  placeholder={"Select an Option"}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            {isDormancyTrackingActive && (
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  name="escheatLiabilityId"
                  label={labelConfig.escheatLiability}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.escheatLiability),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    options={liabilityAccountOptions}
                    placeholder={"Select an Option"}
                    allowClear
                    showSearch
                  />
                </Form.Item>
              </Col>
            )}
          </Row>
        </div>
        <div>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {labelConfig.expenses}
            </Title>
          </Divider>
          <Row>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="interestOnSavingsAccountId"
                label={labelConfig.interestOnSavings}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.interestOnSavings),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  options={expenseAccountOptions}
                  placeholder={"Select an Option"}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="writeOffAccountId"
                label={labelConfig.writeOff}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.writeOff),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  options={expenseAccountOptions}
                  placeholder={"Select an Option"}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {labelConfig.income}
            </Title>
          </Divider>
          <Row>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="incomeFromFeeAccountId"
                label={labelConfig.incomeFromFee}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.incomeFromFee),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  options={incomeAccountOptions}
                  placeholder={"Select an Option"}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="incomeFromPenaltyAccountId"
                label={labelConfig.incomeFromPenalties}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.incomeFromPenalties),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  options={incomeAccountOptions}
                  placeholder={"Select an Option"}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="incomeFromInterestId"
                label={labelConfig.overderaftInterestIncome}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(
                      labelConfig.overderaftInterestIncome
                    ),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  options={incomeAccountOptions}
                  placeholder={"Select an Option"}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <Title level={4}>
          Advanced Accounting Rule:{" "}
          <span>
            {showAdvancedAccounting ? (
              <>
                <Button
                  type="dashed"
                  onClick={() =>
                    setShowAdvancedAccounting(!showAdvancedAccounting)
                  }
                  icon={<DownOutlined />}
                >
                  Hide
                </Button>
              </>
            ) : (
              <>
                <Button
                  type="dashed"
                  onClick={() =>
                    setShowAdvancedAccounting(!showAdvancedAccounting)
                  }
                  icon={<RightOutlined />}
                >
                  Show
                </Button>
              </>
            )}
          </span>
        </Title>
        <Divider style={{ margin: 0, padding: 0 }} />
        {showAdvancedAccounting && (
          <div>
            <ConfigureFundSource
              onFinish={onFinish}
              form={form}
              userData={userData}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              paymentTypeOptions={paymentTypeOptions}
              assetAccountOptions={assetAccountOptions}
              configureFundTableSource={configureFundTableSource}
              setConfigureFundTableSource={setConfigureFundTableSource}
              fundCount={fundCount}
              setFundCount={setFundCount}
            />
            <MapFees
              onFinish={onFinish}
              form={form}
              userData={userData}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              charges={charges}
              incomeAccountOptions={incomeAccountOptions}
              mapFeeTableSource={mapFeeTableSource}
              setMapFeeTableSource={setMapFeeTableSource}
              feeCount={feeCount}
              setFeeCount={setFeeCount}
            />

            {/* <MapPenalties
              onFinish={onFinish}
              form={form}
              userData={userData}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              penaltyOptions={penaltyOptions}
              incomeAccountOptions={incomeAccountOptions}
              mapPenaltyTableSource={mapPenaltyTableSource}
              setMapPenaltyTableSource={setMapPenaltyTableSource}
              penaltyCount={penaltyCount}
              setPenaltyCount={setPenaltyCount}
            /> */}
          </div>
        )}
      </div>
    </Form>
  );
};

export default AccountingForm;
